import { EndingSoonNotification } from 'components/notifications/EndingSoonNotification';
import { NewLiveReferralNotification } from 'components/notifications/NewLiveReferralNotification';
import { NewValueCaseNotification } from 'components/notifications/NewValueCaseNotification';
import { OutbidNotification } from 'components/notifications/OutbidNotification';
import { PendingIntakeNotification } from 'components/notifications/PendingIntakeNotification';

export const NotificationTypes = {
    END_SOON: 'END_SOON',
    NEW_REFER: 'NEW_REFER',
    OUTBID: 'OUTBID',
    PENDINTAKE: 'PENDINTAKE',
    VCATTACHED: 'VCATTACHED',
    // Summary emails
    WORKSUM: 'WORKSUM',
    LIVEREFSUM: 'LIVEREFSUM',
    WONREFSUM: 'WONREFSUM',
} as const;

// notification component map
export const NotificationComponentMap = {
    [NotificationTypes.END_SOON]: EndingSoonNotification,
    [NotificationTypes.NEW_REFER]: NewLiveReferralNotification,
    [NotificationTypes.OUTBID]: OutbidNotification,
    [NotificationTypes.PENDINTAKE]: PendingIntakeNotification,
    [NotificationTypes.VCATTACHED]: NewValueCaseNotification,
} as const;
